"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var FilterKey = _interopRequireWildcard(require("../../../constants/search/FilterKey"));

var _FilterTag = _interopRequireDefault(require("./FilterTag"));

var ResultsFilters = function ResultsFilters(_ref) {
  var filters = _ref.filters,
      onClearFilters = _ref.onClearFilters,
      onFilterChange = _ref.onFilterChange,
      trackInteraction = _ref.trackInteraction,
      validFilterTagKeys = _ref.validFilterTagKeys;
  var activeCategory = filters[FilterKey.CATEGORY];
  var handleCloseFilterTag = (0, _react.useCallback)(function (filterKey, value) {
    var filterValue = filters.get(filterKey);
    onFilterChange(filterKey, _immutable.default.Set.isSet(filterValue) ? filterValue.delete(value) : null);
  }, [filters, onFilterChange]);
  var renderedTags = (0, _react.useMemo)(function () {
    return validFilterTagKeys.reduce(function (final, key) {
      var value = filters.get(key);

      if (!_immutable.default.Set.isSet(value)) {
        value = _immutable.default.Set.of(value);
      }

      var tagProps = {};

      if (key === FilterKey.CATEGORY_FEATURES) {
        tagProps = {
          activeCategory: activeCategory
        };
      }

      value.forEach(function (val) {
        final.push(_react.default.createElement(_FilterTag.default, (0, _extends2.default)({}, tagProps, {
          key: key + ":" + val,
          filterKey: key,
          onCloseClick: function onCloseClick() {
            handleCloseFilterTag(key, val);
            trackInteraction('close filter tag', {
              filter: key,
              value: val
            });
          },
          value: val
        })));
      });
      return final;
    }, []);
  }, [activeCategory, filters, handleCloseFilterTag, trackInteraction, validFilterTagKeys]);

  if (!renderedTags.length) {
    return null;
  }

  return _react.default.createElement(_UIFlex.default, {
    align: "center",
    wrap: "wrap"
  }, renderedTags, _react.default.createElement(_UIButton.default, {
    className: "m-left-3",
    onClick: function onClick(evt) {
      onClearFilters(evt);
      trackInteraction('clear all filters', {
        filterCount: renderedTags.length
      });
    },
    use: "link"
  }, _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.storefront.results.resultsPage.clearFiltersText"
  }))));
};

ResultsFilters.propTypes = {
  filters: CustomPropTypes.storefrontFilters.isRequired,
  onClearFilters: _propTypes.default.func.isRequired,
  onFilterChange: _propTypes.default.func.isRequired,
  trackInteraction: _propTypes.default.func.isRequired,
  validFilterTagKeys: _reactImmutableProptypes.default.orderedSetOf(_propTypes.default.oneOf(Object.values(FilterKey))).isRequired
};
var _default = ResultsFilters;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/ResultsFilters.js
// module id = 902
// module chunks = 209 210 211 212